import React, { createContext, useContext, useState, ReactNode } from 'react';
import {StandardVideo} from "../../reactvideoeditor/pro/types/media-adaptors";
import {CollectionClip} from "../../types/collectionTypes";
import {isHLS} from "../../utils/editor/editorUtils";

type VideoElement = StandardVideo & { _source: string; _sourceDisplayName: string; stream_time_start?: number; stream_time_end?: number;}

interface EditorSelectedElementsType {
    selectedElements: VideoElement[];
    setSelectedElements: (selectedElements: VideoElement[]) => void;
    setKeyMomentsAsSelectedElements : (keyMoments: CollectionClip[]) => void;
}


function convertKeyMoment(keyMoment: CollectionClip): VideoElement{
    const videoElements: VideoElement = {
        _source: 'video',
        _sourceDisplayName: 'video',
        type: 'video',
        height: 1080,
        width: 1920,
        duration: keyMoment.duration,
        id: keyMoment.id,
        isLocked: false,
        thumbnail: keyMoment.thumbnail,
        videoFiles: [
            {
                format: 'video/mp4',
                url: keyMoment.url,
                quality: "low"
            }
        ]
    }

    if(isHLS(keyMoment.url)){
        videoElements.stream_time_start = keyMoment.stream_time_start
        videoElements.stream_time_end = keyMoment.stream_time_end
    }

    return videoElements
}

const EditorSelectedElementsContext = createContext<EditorSelectedElementsType | undefined>(undefined);

export const EditorSelectedElementsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [selectedElements, setSelectedElements] = useState<VideoElement[]>([]);



    function setKeyMomentsAsSelectedElements(keyMoments: CollectionClip[]): void{
        setSelectedElements(keyMoments.map(km => convertKeyMoment(km)))
    }

    return (
        <EditorSelectedElementsContext.Provider value={{ selectedElements, setSelectedElements, setKeyMomentsAsSelectedElements}}>
            {children}
        </EditorSelectedElementsContext.Provider>
    );
};

export const useSelectedEditorItems = (): EditorSelectedElementsType => {
    const context = useContext(EditorSelectedElementsContext);
    if (!context) {
        throw new Error('useSelectedEditorItems deve essere usato all’interno di un EditorSelectedElementsProvider');
    }
    return context;
};